import { Context } from '@nuxt/types';

export default async function(context: Context) {
  const { app, route, from } = context;

  const mixpanelEventProperties = {
    routeVisited: route.path,
    previousRoute: from.path,
  };

  app.$mixpanel.track('Route Change', mixpanelEventProperties);
}
